import * as React from 'react'

export const Unauthorized: React.FunctionComponent = () => {
    return <div>
        <p>Sorry, but you do not have permissions to do that.</p>
        <p>If you believe this message is an error, please contact us.</p>
    </div>
}
